import moment from 'moment';
import useArticle from '../../ArticleOverview/hooks/useArticle';
import image from './image_1.jpg';
import image_2 from './image_2.jpg';

const useStory = () =>
    useArticle({
        title: 'Worstenactie Rehoboth IJsselmuiden 2025',
        date: moment('2025-11-15 10:00'),
        image: image,
        summary: (
            <>
                Rond Dankdag hebben de leerlingen van de Rehoboth in
                IJsselmuiden zich ingezet voor de worstenactie. Dankzij hun
                enthousiasme en inzet is er maar liefst €2.729,00 opgehaald voor
                Sarfath!
            </>
        ),
        content: (
            <>
                <div className="row mb-3">
                    <div className="col-12 col-xs-6 col-md-4">
                        <img
                            src={image}
                            className="img-fluid img-thumbnail"
                            alt=""
                        />
                    </div>
                    <div className="col">
                        Rond Dankdag hebben de leerlingen van de Rehoboth in
                        IJsselmuiden zich ingezet voor de worstenactie. De
                        kinderen hebben heel erg hun best gedaan en dat is te
                        zien aan het resultaat: er kon maar liefst €2.729,00
                        overgemaakt worden naar Sarfath.
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-xs-6 col-md-4">
                        <img
                            src={image_2}
                            className="img-fluid img-thumbnail"
                            alt=""
                        />
                    </div>
                    <div className="col">Allen hartelijk dank!</div>
                </div>
            </>
        ),
    });

export default useStory;
